import { useQuery } from "@tanstack/react-query";
import adminApiClient from "../../../api/admin";

const useGetLastVersionNumber = (clockId: string, enabled = true) => {
  return useQuery({
    queryKey: ["lastVersionNumber", clockId],
    queryFn: () => adminApiClient.getLastVersionNumber(clockId),
    enabled: enabled && !!clockId,
  });
};

export default useGetLastVersionNumber;
